import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function BottomPricing() {
  return <section className="py-16 px-4 bg-dark-card border-t border-dark-border pt-[25px] pb-[25px]" data-id="element-77">
      <div className="max-w-lg mx-auto" data-id="element-78">
        <div className="text-center mb-10" data-id="element-79">
          <div className="text-white font-bold mb-4 tracking-widest text-sm flex items-center justify-center gap-2" data-id="element-80">
            <span data-id="element-81">🚨</span>
            <span data-id="element-82">EL PRECIO DE LANZAMIENTO CIERRA EN:</span>
          </div>
          <CountdownTimer data-id="element-83" />
        </div>

        <div className="flex flex-col gap-6" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark border border-dark-border rounded-2xl p-6 text-center" data-id="element-85">
            <div className="text-3xl mb-2" data-id="element-86">📘</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-87">
              ULTRAPACK TERAPÉUTICO PRO™
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-88">6 Tomos + 6 Bonos</p>

            <div className="mt-5" data-id="element-89">
              <div className="text-gray-500 line-through text-sm" data-id="element-90">
                Antes: $34.990 ARS
              </div>
              <div className="text-3xl md:text-4xl font-black text-white mt-1" data-id="element-91">
                Hoy: $19.990 ARS
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47862967894190:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(219,39,119,0.3)] text-base" data-id="element-92">
              → QUIERO MI ULTRAPACK
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-dark border-2 border-brand rounded-2xl p-6 text-center shadow-[0_0_40px_rgba(219,39,119,0.15)]" data-id="element-93">
            <div className="text-3xl mb-2" data-id="element-94">🏆</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-95">
              ULTRAPACK TERAPÉUTICO PRO™ + AT MASTER-DOC™ ⭐ LA MÁS ELEGIDA
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-96">
              6 Tomos + 6 Bonos + AT MASTER-DOC™ (Documentación blindada,
              contratos élite, facturación y rentabilidad)
            </p>

            <div className="mt-5" data-id="element-97">
              <div className="text-gray-500 line-through text-sm" data-id="element-98">
                Antes: $43.990 ARS
              </div>
              <div className="text-3xl md:text-4xl font-black text-brand mt-1" data-id="element-99">
                Hoy: $27.990 ARS
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47862969008302:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(219,39,119,0.4)] text-base" data-id="element-100">
              → QUIERO EL ULTRAPACK + AT MASTER-DOC™
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}